import BuyCredit from 'containers/Administration/BuyCredit';
import HiredNumber from 'containers/Administration/HiredNumber';

export default [
  {
    name: 'hiredNumbers',
    component: HiredNumber,
    path: '/hired-numbers',
    icon: 'fas fa-phone-square',
    layout: '/in/administration',
  },
  {
    name: 'hireNewNumber',
    component: BuyCredit,
    path: '/hire-new-number',
    icon: 'far fa-plus-square',
    layout: '/in/administration',
  },
];
